import AspectRatioComponent from "components/aspect-ratio";
import Image from "next/image";
import { Button } from "components/ui/button";
import { LinkTrackers } from "~/components/reusables/link-trackers";

export function QRNGBannerSM({ QRNGData }) {
  const img = QRNGData?.ui[0]?.icon?.data?.attributes;
  const ctaBtn = QRNGData?.ui[0];
  return (
    <div className="relative">
      <div className="relative overflow-hidden rounded-xl border border-white bg-gradient-to-br from-[#4A9929]  via-[#002F3B] via-50% to-[#002F3B]">
        <div className="absolute h-full w-full bg-gradient-to-r from-[#00000016] to-[#0000001f]"></div>
        <div className="absolute h-full w-full bg-gradient-to-b from-[#00000000] via-[#0000009c] via-60% to-[#000000]"></div>
        <div className="absolute bottom-0 right-0 z-10 w-full">
          <AspectRatioComponent aspectRatio={{ width: 424, height: 251 }}>
              <Image
                unoptimized
                src="/images/pages/blog/0011.webp"
                fill
                alt="Logo"
                className=""
              />
            </AspectRatioComponent>
        </div>
        <div className="relative z-20 px-[20px] pb-16 pt-10 text-white ">
          <div className={"w-11/12 max-w-64 pb-8 lg:w-full lg:max-w-56"}>
            <AspectRatioComponent aspectRatio={{ width: 247, height: 43 }}>
              <Image
                unoptimized
                src="/images/pages/blog/outshift-quantum-lab.webp"
                fill
                alt="Logo"
                className=""
              />
            </AspectRatioComponent>
          </div>
          <h2 className="font-h1 md:font-h3 mb-3">
            Experience quantum in action
          </h2>
          <p className="font-p pt-4 lg:max-w-56">
            Powered by Outshift's Quantum Random Number Generator
          </p>
          <div className="flex py-12">
            <div className="group relative">
              <div className="absolute left-0 top-0 h-full w-full blur group-hover:bg-gradient-to-r group-hover:from-[#7A22D1] group-hover:to-[#00C4D3] group-active:from-[#7A22D1] group-active:to-[#00C4D3]"></div>
              <Button
                aria-label="button"
                className="duration-3500 relative h-12 w-full rounded-lg border-none bg-gradient-search-bar px-6 text-white transition ease-in-out hover:from-[#7A22D1] hover:to-[#00C4D3] active:from-[#7A22D1] active:to-[#00C4D3] md:px-8"
              >
                <LinkTrackers
                  href={ctaBtn?.url}
                  className="font-btn-lg flex items-center gap-2"
                  segmentMsg="Banner Link Clicked"
                  segmentOpt={{
                    link_label: "Try it now",
                    location: "banner",
                    location_detail: "right-header",
                    resource_interaction: "visit the QRNG page",
                  }}
                >
                  {ctaBtn?.cta}
                </LinkTrackers>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
